import React, { Component } from 'sitewide-react';
import PropTypes from 'prop-types';

const textWrappingButtonStyle = {
  whiteSpace: 'normal',
};

class OnsitePing extends Component {
  constructor(props) {
    super(props);
    this.closeRef = React.createRef();
  }

  createCloseTooltip(pingName) {
    return (e) => {
      e.preventDefault();
      $.ajax({
        type: 'POST',
        url: $r.record_ping_dismissal_api_v0_onsite_pings_path({
          subdomain_param: 'api',
        }),
        contentType: 'application/json',
        processData: false,
        data: JSON.stringify({
          ping_name: pingName,
        }),
      });

      const pingContainer = document.getElementById('onsite-ping');
      pingContainer.classList.remove('visible');

      let event;
      if (typeof Event === 'function') {
        event = new Event('dismiss');
      } else {
        event = document.createEvent('Event');
        event.initEvent('dismiss', true, true);
      }
      pingContainer.dispatchEvent(event);
    };
  }

  getTitle() {
    // Not implemented
  }

  getBody() {
    // Not implemented
  }

  getUpgradeURL() {
    // Not Implemented
  }

  getButtonText() {
    // Not Implemented
  }

  getIconClassName() {
    // Not Implemented
  }

  renderTopSection() {
    return (
      <div className="ping-header">
        <div className="title">{this.getTitle()}</div>
        <div className="close-button-wrapper">
          <button
            ref={this.closeRef}
            className="close-button"
            onClick={this.createCloseTooltip(this.props.pingName)}
          >
            ×
          </button>
        </div>
      </div>
    );
  }

  renderMainSection() {
    return (
      <div className="ping-main">
        {!$a.isSmallScreen() && (
          <div className="icon-wrapper">
            <i className={this.getIconClassName()} />
          </div>
        )}
        <div>{this.getBody()}</div>
      </div>
    );
  }

  redirectToUpgradeUrl = () => {
    $.ajax({
      type: 'POST',
      url: $r.record_ping_clickthrough_api_v0_onsite_pings_path({
        subdomain_param: 'api',
      }),
      contentType: 'application/json',
      processData: false,
      data: JSON.stringify({
        ping_name: this.props.pingName,
      }),
    });

    window.location = this.getUpgradeURL();
  };

  onBodyClick = (event) => {
    if (event.target === this.closeRef.current) return;
    this.redirectToUpgradeUrl(); // TODO Replace with anchor tag.
  };

  renderButton() {
    const buttonSizeClass = $a.isSmallScreen() ? 'Button--lg' : 'Button--sm';

    return (
      <div className="ping-button">
        <button
          style={textWrappingButtonStyle}
          className={'Button Button--round ' + buttonSizeClass}
        >
          <div className="button-text">{this.getButtonText()}</div>
        </button>
      </div>
    );
  }

  renderBasePing() {
    return (
      <div className="ping-wrapper u-clickable" onClick={this.onBodyClick}>
        {this.renderTopSection()}
        {this.renderMainSection()}
        {this.renderButton()}
      </div>
    );
  }

  renderMobilePing() {
    return <div className="mobile-popover">{this.renderBasePing()}</div>;
  }

  render() {
    if ($a.isSmallScreen()) {
      return this.renderMobilePing();
    } else {
      return this.renderBasePing();
    }
  }
}

OnsitePing.propTypes = {
  pingName: PropTypes.string.isRequired,
};

export default OnsitePing;
